<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="UI빌더 제안 목록"
      desc="">
    </admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="created_time" slot-scope="props">
        {{ datesFormat(props.item.created_time, 'date_4') }}
      </div>

      <div slot="title" slot-scope="props">
        <span class="unselect"
              style="text-decoration: underline"
              @click="routerPush(`template/detail?id=${props.item.id}`)">{{ props.item.title }}</span>
      </div>
      <div slot="content" slot-scope="props">
        <span class="unselect"
              style="text-decoration: underline"
              @click="routerPush(`template/detail?id=${props.item.id}`)">{{ props.item.content }}</span>
      </div>
      <div slot="status" slot-scope="props">
        <span class="select">
          <select v-model="props.item.status" @change="e=>changeStatus(e, props.item.id)">
            <option v-for="(status, s_idx) in statusArr" :key="`status-${s_idx}`" :value="status.value">{{ status.label }}</option>
          </select>
        </span>
      </div>
      <div slot="user" slot-scope="props">
        <template v-if="props.item && props.item.service && props.item.service.service_user">
            {{ props.item.service.service_user.name }}<br>
            {{ props.item.service.service_user.email }}<br>
            {{ props.item.service.service_user.phone }}
        </template>
      </div>
    </admin-table>
  </div>
</template>
<script>
  import ListMixin from "@/mixins/ListMixin";

  export default {
    name: "TemplateInquiry",
    mixins: [
      ListMixin
    ],
    created() {
      this.initializing('launchpack_template_inquiry', 'launchpack/inquiry/template');
    },
    data() {
      return {
        statusArr: [
          { label: '미확인', value: 0 },
          { label: '진행중', value: 1 },
          { label: '보류', value: 2 },
          { label: '진행안함', value: 3 },
          { label: '진행완료', value: 4 },
        ]
      }
    },
    methods: {
      getDataFromServer() {
        this.getData();
      },
      changeStatus(e, id) {
        this.$axios.post(`admin/launchpack/inquiry/template/${id}/status/change`, {
          status: parseInt(e.target.value)
        }).then(res=>{
          this.toast('진행 상태가 변경되었습니다.');
        }).catch(error=>{
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
